export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchase?',
    a: "You'll get immediate access to all the material so you can start using it right away — no waiting, no complicated steps.",
  },
  {
    q: 'What level of Ninja coach is this for?',
    a: 'Ninja Coach Ready is designed for coaches at all levels — from coaches just starting out who need structure, to experienced coaches who need variety and professional systems. Every volume includes easy, standard, and advanced versions of every class, so there’s always appropriate content for your group.',
  },
  {
    q: 'Does this work for Ninja coaches in any country?',
    a: 'Yes. Ninja Coach Ready is designed to be universally applicable — whether you work in a large facility, small space, with complete equipment, or limited resources. The system includes adaptations for every scenario.',
  },
  {
    q: 'Can I edit the material?',
    a: 'Yes. All material is in editable PDF format, so you can adapt names, add your own cues, change class durations, or personalize based on your specific needs.',
  },
  {
    q: 'What currency will I pay in?',
    a: 'You pay in your local currency. The system detects your geographic location and converts the price automatically.',
  },
  {
    q: "What if I don't find it useful?",
    a: 'Contact us within 7 days of your purchase and we will refund 100% of your money — no questions, no forms, no hassle.',
  },
]
